import React from 'react';
import { Link } from 'react-router-dom';
import AppsLayout from './AppsLayout';
import Reveal from './components/Reveal';
import Badge from './components/Badge';
import Button from './components/Button';
import { trackClick } from '../../firebase/analytics';
import { APPS_ROUTES } from './routes';

const PAGE = 'apps_qr_code_licenses';

export default function QrCodeLicensesPage() {
  return (
    <AppsLayout
      theme="portfolio"
      title="QR code generator licenses · Portfolio · Keval Langalia"
      description="Open-source notices and third-party software licenses for the browser-based QR code generator on keval.io."
      canonicalPath={APPS_ROUTES.qrCodeLicenses}
      breadcrumbs={[
        { label: 'Portfolio', to: APPS_ROUTES.apps, id: 'apps' },
        { label: 'QR code generator', to: APPS_ROUTES.qrCode, id: 'qr_code' },
        { label: 'Licenses' },
      ]}
      page={PAGE}
      support={false}
    >
      <Reveal as="section" className="apps-hero" aria-labelledby="qr-licenses-heading">
        <p className="apps-eyebrow">Portfolio · Web tool</p>
        <h1 id="qr-licenses-heading" className="apps-title">Third-party licenses</h1>
        <p className="apps-lead">
          The browser-based QR code generator includes open-source software from the projects below. Their copyright and permission notices are reproduced here.
        </p>
      </Reveal>

      <div className="apps-licenses-view">
        <section className="kds-pane apps-license-card" aria-labelledby="qrcode-react-heading">
          <div className="apps-license-card-header">
            <h2 id="qrcode-react-heading" className="apps-license-card-title">qrcode.react</h2>
            <Badge variant="accent">ISC License</Badge>
          </div>
          <p className="apps-license-meta">
            Copyright (c) 2015, Paul O'Shannessy ·{' '}
            <a
              href="https://github.com/zpao/qrcode.react"
              target="_blank"
              rel="noopener noreferrer"
              className="kds-link"
            >
              github.com/zpao/qrcode.react
            </a>
            <br />
            Used for encoding and rendering QR codes in the browser.
          </p>
          <pre className="apps-license-pre">
{`Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.`}
          </pre>
        </section>

        <section className="kds-pane apps-license-card" aria-labelledby="nayuki-heading">
          <div className="apps-license-card-header">
            <h2 id="nayuki-heading" className="apps-license-card-title">QR Code generator library (TypeScript)</h2>
            <Badge variant="accent">MIT License</Badge>
          </div>
          <p className="apps-license-meta">
            Copyright (c) Project Nayuki ·{' '}
            <a
              href="https://www.nayuki.io/page/qr-code-generator-library"
              target="_blank"
              rel="noopener noreferrer"
              className="kds-link"
            >
              nayuki.io
            </a>
            <br />
            Bundled inside qrcode.react.
          </p>
          <pre className="apps-license-pre">
{`Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`}
          </pre>
        </section>

        <section className="apps-notice apps-notice--info" aria-labelledby="trademarks-heading">
          <strong id="trademarks-heading">Trademarks</strong>
          <p>
            QR Code is a registered trademark of DENSO WAVE INCORPORATED. The QR Code symbology is published as ISO/IEC 18004 and DENSO WAVE states that it may be used freely, including commercially, when the standard is followed.
          </p>
        </section>

        <div className="apps-hero-actions">
          <Button to={APPS_ROUTES.qrCode} variant="secondary" onClick={trackClick(PAGE, 'back_to_qr_button')}>
            Back to QR code generator
          </Button>
          <Link to={APPS_ROUTES.apps} className="kds-btn kds-btn--text" onClick={trackClick(PAGE, 'all_apps_link')}>
            All projects
          </Link>
        </div>
      </div>
    </AppsLayout>
  );
}
